import type { Benefit } from '../types/offer'

export const benefits: Benefit[] = [
  {
    icon: 'target',
    title: 'STOP BEING THE CHEAPEST OPTION',
    description:
      'Learn to position yourself as the premium choice in any market. Double (or triple) your earning potential within 90 days.',
  },
  {
    icon: 'muscle',
    title: 'BUILD UNBREAKABLE CONFIDENCE',
    description:
      'Master the psychology that transforms self-doubt into unshakeable belief. Never feel small or inadequate again, no matter the circumstances.',
  },
  {
    icon: 'pressure',
    title: 'WIN HIGH-PRESSURE MOMENTS',
    description:
      'Develop the exact mindset used by champions under extreme pressure. Crush job interviews, client presentations, and life-changing decisions.',
  },
  {
    icon: 'wealth',
    title: 'CREATE SUSTAINABLE WEALTH',
    description:
      'Stop trading time for money. Build systems that generate income automatically. Achieve financial freedom using proven Argentine business psychology.',
  },
  {
    icon: 'brain',
    title: 'REPROGRAM YOUR BELIEFS',
    description:
      'Eliminate limiting beliefs that keep you broke and stuck. Adopt the exact thought patterns of the world\u2019s most successful people.',
  },
  {
    icon: 'community',
    title: 'JOIN AN ELITE COMMUNITY',
    description:
      'Access to 2,847+ ambitious Bangladesh youth with the same vision. Network, collaborate, and grow together with your peers.',
  },
]
